// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"559":"02c28ba5","787":"20833fca"}[chunkId] + ".chunk.js";
};